<template>
  <v-app>
    <app-header></app-header>
      <div id="app">
        <router-view/>
      </div>
      <app-footer></app-footer>
  </v-app>
</template>

<script>
import AppHeader from "@/components/Header.vue";
import AppFooter from "@/components/Footer.vue";
export default {
    data(){
        return {
            name: 'App'
        }
    },
    created(){

    },
    components: {
      AppHeader,
      AppFooter
    },
    mounted(){

    },
    computed: {

    },
    watch:{

    },
    methods: {

    },
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/App.vue